"use client"

import { Container, SimpleGrid, Box, Title, Text, ThemeIcon, Stack } from "@forestsync/ui"
import { TbShieldCheck, TbLock, TbSatellite, TbBuildingEstate } from "react-icons/tb"
import { useTranslations } from "next-intl"

export function LandingTrustBand() {
  const t = useTranslations("landing")

  const pillars = [
    {
      icon: TbShieldCheck,
      title: t("trustAdditionalityTitle"),
      body: t("trustAdditionalityDesc"),
    },
    {
      icon: TbLock,
      title: t("trustPermanenceTitle"),
      body: t("trustPermanenceDesc"),
    },
    {
      icon: TbSatellite,
      title: t("trustMrvTitle"),
      body: t("trustMrvDesc"),
    },
    {
      icon: TbBuildingEstate,
      title: t("trustCrcfTitle"),
      body: t("trustCrcfDesc"),
    },
  ]

  return (
    <Box py={80} bg="var(--mantine-color-default-hover)">
      <Container size="lg">
        <Title order={2} ta="center" mb="xl">{t("trustTitle")}</Title>
        <SimpleGrid cols={{ base: 2, md: 4 }} spacing="xl">
          {pillars.map(({ icon: Icon, title, body }) => (
            <Stack key={title} gap="sm" align="flex-start">
              <ThemeIcon size={48} radius="lg" color="forest" variant="light">
                <Icon size={24} />
              </ThemeIcon>
              <Title order={4}>{title}</Title>
              <Text size="sm" c="dimmed" lh={1.7}>{body}</Text>
            </Stack>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  )
}
